import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function HeadlightRestorationPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Headlight Restoration',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Professional headlight restoration service to remove yellowing, oxidation, and fog, improving nighttime visibility and vehicle appearance.'
  };
  return <ServicePageLayout title="Headlight Restoration in Los Angeles & Ventura County" subtitle="Improve your nighttime visibility and enhance your car's appearance by permanently removing yellowing, oxidation, and fog from your headlights." metaDescription="Professional headlight restoration in Camarillo, Thousand Oaks, and Ventura County. Remove yellowing and oxidation for clear headlights. Call (818) 381-9905." schema={schema} data-id="element-364">
      <p data-id="element-365">
        Are your vehicle's headlights looking cloudy, yellowed, or foggy? Not
        only does this age the appearance of your car significantly, but it also
        poses a serious safety hazard by drastically reducing your nighttime
        visibility. At Mike's Pro Detail, our professional{' '}
        <strong data-id="element-366">Headlight Restoration</strong> service permanently removes heavy
        oxidation and restores crystal-clear clarity to your lenses. We provide
        this essential mobile service throughout Camarillo CA, Thousand Oaks,
        and the greater Ventura County area.
      </p>

      <h2 data-id="element-367">Why Do Headlights Turn Yellow?</h2>
      <p data-id="element-368">
        Modern vehicle headlights are made of polycarbonate plastic, which is
        lightweight and impact-resistant. However, this plastic is highly
        susceptible to UV degradation from the sun. Manufacturers apply a
        UV-protective clear coat at the factory, but over time, this coating
        breaks down due to sun exposure, heat from the bulbs, and harsh cleaning
        chemicals. Once the coating fails, the plastic oxidizes rapidly,
        resulting in that cloudy, yellow appearance.
      </p>

      <h2 data-id="element-369">Our Professional Restoration Process</h2>
      <p data-id="element-370">
        Don't be fooled by cheap DIY kits or "wipe-on" fixes that only last a
        few weeks. We perform a true, multi-step mechanical restoration to
        permanently fix the issue:
      </p>

      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-371">
        <li className="flex items-start" data-id="element-372">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-373" />
          <span data-id="element-374">
            <strong data-id="element-375">Taping & Protection:</strong> We carefully tape off the
            surrounding paint and trim to ensure no damage occurs during the
            sanding process.
          </span>
        </li>
        <li className="flex items-start" data-id="element-376">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-377" />
          <span data-id="element-378">
            <strong data-id="element-379">Wet Sanding:</strong> We use progressive grits of
            specialized sandpaper to completely strip away the failed factory
            clear coat and the oxidized plastic layer.
          </span>
        </li>
        <li className="flex items-start" data-id="element-380">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-381" />
          <span data-id="element-382">
            <strong data-id="element-383">Machine Compounding:</strong> Using a machine polisher and
            heavy cutting compound, we remove the fine sanding marks and begin
            restoring clarity.
          </span>
        </li>
        <li className="flex items-start" data-id="element-384">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-385" />
          <span data-id="element-386">
            <strong data-id="element-387">Machine Polishing:</strong> A refining polish is used to
            bring the polycarbonate lens back to a flawless, glass-like
            transparency.
          </span>
        </li>
        <li className="flex items-start" data-id="element-388">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-389" />
          <span data-id="element-390">
            <strong data-id="element-391">UV Protection Application:</strong> This is the most
            critical step. We apply a durable ceramic coating or specialized UV
            sealant to protect the bare plastic and prevent it from yellowing
            again.
          </span>
        </li>
      </ul>

      <h2 data-id="element-392">Safety and Aesthetics</h2>
      <p data-id="element-393">
        Restoring your headlights is one of the most cost-effective ways to
        instantly improve the look of your vehicle. More importantly, clear
        headlights allow your bulbs to project light properly, significantly
        improving your vision at night and during inclement weather, keeping you
        and your family safe on the road.
      </p>

      <h2 data-id="element-394">Convenient Mobile Service</h2>
      <p data-id="element-395">
        Replacing headlight assemblies can cost hundreds or even thousands of
        dollars. Our restoration service is a fraction of the cost and yields
        incredible results. If you are searching for "Mobile Detailing Ventura
        County" or "Car Detailing Camarillo" to fix your cloudy headlights,
        Mike's Pro Detail will come directly to your home or workplace to
        perform the restoration.
      </p>
    </ServicePageLayout>;
}